import { takeLatest } from "redux-saga/effects";
import getCategoriesWorker from "./getCategoriesWorker";
import updateCategoriesWorker from "./updateCategoriesWorker";

export function* moneyWatcher() {
    yield takeLatest("money/getCategoriesFetch", getCategoriesWorker);
    yield takeLatest("money/updateCategoriesFetch", updateCategoriesWorker);
}